import { render, staticRenderFns } from "./BrandDescriptionSection.vue?vue&type=template&id=1d408ecd&scoped=true"
import script from "./BrandDescriptionSection.vue?vue&type=script&lang=js"
export * from "./BrandDescriptionSection.vue?vue&type=script&lang=js"
import style0 from "./BrandDescriptionSection.vue?vue&type=style&index=0&id=1d408ecd&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d408ecd",
  null
  
)

export default component.exports